import infoJson from './info.json';

export interface Info {
  name: string;
  version: string;
  commit: string;
  commitShort: string;
  branch: string;
  tag: string;
  refName: string;
  buildNumber: string;
  buildTime: string;
}

export const environment = {
  production: true,
  info: {
    name: infoJson.name,
    version: infoJson.version,
    commit: infoJson.commit,
    commitShort: infoJson.commitShort,
    branch: infoJson.branch,
    tag: infoJson.tag,
    refName: infoJson.refName,
    buildNumber: infoJson.buildNumber,
    buildTime: infoJson.buildTime,
  } as Info,
};
